var Flickity = require("flickity");
require("flickity-fade");

if (window.outerWidth <= 800){
  var mediaChoiceCarousel = new Flickity("#media-choice-carousel", {
    autoPlay: 4500,
    adaptiveHeight: false,
    pageDots: true,
    prevNextButtons: true,
    cellAlign: "left",
    wrapAround: true,
    contain: true
  });
} else {
    var mediaChoiceCarousel = new Flickity("#media-choice-carousel", {
    autoPlay: 4500,
    adaptiveHeight: false,
    pageDots: false,
    prevNextButtons: true,
    cellAlign: "left",
    wrapAround: true,
    contain: true
  });
}